export enum AnswerValueEnum {
  DBL = "DBL",
  RDBL = "RDBL",
  PASS = "PASS"
}

export enum TypeBlurEnum {
  START = "start",
  STYLE = "style",
  SHOW_CARD = "show-card"
}

export enum TypeCardEnum {
  HORIZONTAL = "horizontal",
  NORTH = "north",
  SOUTH = "south",
  EAST = "east",
  WEST = "west"
}

export enum VideoTypeEnum {
  STATIC = 1,
  YOUTUBE = 2,
  VIMEO = 3
}

export enum PaginationArrowEnum {
  RIGHT = "right",
  LEFT = "left"
}

export enum FontColorEnum {
  BLUE = "blue",
  GREEN = "green",
  WHITE_BLUE = "white_blue"
}

export enum BiddingEnum {
  INTERACTIVE_BIDDING = "interactive-bidding",
  BIDDING = "bidding"
}
